export default {
    dataPicker: {
        feedback: 'Поле обязательно для заполнения!',
    },

    excel: {
        button: 'Выгрузка списка в Excel',
    },

    multiselect: {
        selectLabel: 'Нажмите для выбора',
        selectedLabel: 'Выбрано',
        deselectLabel: 'Нажмите для снятия',
        noOptions: 'Список пуст',
        noResult: 'Информация не найдена',
        invalid: 'Поле обязательно для заполнения!',
    },

    selectEditField: {
        formSelectError: 'Пожалуйста, укажите причину переноса даты',
    },

    customFrom: '{firstParam} от {secondParam}',

    reportHandler: {
        heading: 'Загрузка файла',
        description: 'Описание',
        download: 'Скачать',
        reset: 'Сбросить',
        info: 'Дополнительная информация',
        handled: 'Файл успешно обработан, нажмите кнопку «Скачать»',
        fileNotSelected: 'Файл не выбран',
        chooseFile: 'Выберите файл',
        error: 'Что-то пошло не так...',
        kuper: {
            header: 'Отчет по заказам Купер-витрина',
            description: 'Формирует отчет по заказам Купер-витрина, включая дату и время получения вебхука order.recieved',
            info: 'Скачать шаблон {link} для заполнения',
            template: '.xlsx-файла',
            error: 'Не удалось получить имя файл',
        },
    },
};